import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsertRowAboveIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 13.8332H11.7333C9.49312 13.8332 8.37302 13.8332 7.51737 13.3972C6.76472 13.0137 6.1528 12.4018 5.76931 11.6491C5.33333 10.7935 5.33333 9.67338 5.33333 7.43317V3.1665M5.33333 3.1665L8.66667 6.49984M5.33333 3.1665L2 6.49984",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgInsertRowAboveIcon;
